import Vue from 'vue'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules';

extend('email', {
  ...email,
  message: 'Please enter a valid Email Address'
})

extend('required', {
  ...required,
  message: (field) => `${field} is a required field`
})
